import React, { useEffect, useRef } from 'react';
import { storyblokEditable} from '@storyblok/react';
import { render } from 'storyblok-rich-text-react-renderer';


const ProductService = ({ blok }) => {
  const serviceRef = useRef(null);

  // Fix links to open in new tab after rendering
  useEffect(() => {
    if (serviceRef.current) {
      const links = serviceRef.current.querySelectorAll('a');
      links.forEach(link => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }, [blok._uid]);

  return (
    <div ref={serviceRef} {...storyblokEditable(blok)} className="product-service">
      <h2>{blok.title}</h2>
      <div>
        {render(blok.description)}
      </div>
      <div className="asset-gallery">
        {blok.assets.map((asset) => (
          <img src={asset.filename} alt="" key={asset.id} />
        ))}
      </div>
    </div>
  );
};

export default ProductService;